import React from 'react';
import { node, oneOf, oneOfType, string } from 'prop-types';

import { BTN_SIZE_PROPS } from '../constants';
import { normalizeIcon } from '../helpers';
import { styBtnTextIcon } from '../style';

const TextIcon = (props) => {
  const { icon, iconPosition, children, size } = props;

  const testId = iconPosition === 'left' ? 'icoLeft' : 'icoRight';
  const styTextIconChildProps = { icon, iconPosition, size };

  return (
    <span data-testid={testId} className={styBtnTextIcon(styTextIconChildProps)}>
      {icon && iconPosition === 'left' && normalizeIcon(icon)}
      {children}
      {icon && iconPosition === 'right' && normalizeIcon(icon)}
    </span>
  );
};

TextIcon.propTypes = {
  children: oneOfType([node, string]),
  icon: oneOfType([node, string]),
  iconPosition: oneOf(['left', 'right']),
  size: oneOf(BTN_SIZE_PROPS),
};

TextIcon.defaultProps = {
  children: null,
  icon: '',
  iconPosition: 'left',
  size: 'sm',
};

export default TextIcon;
